import { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import * as Sentry from "@sentry/browser";

import { toast } from "@/design-system/components/Toast/Toast";

import { makeRequest } from "./util";

import { invalidateEventDefs } from "./api/useEventDefs";
import useListAllDestinationsForEnv from "./destinations/v2/hooks/useListAllDestinationsForEnv";

export const DestinationOAuth = ({ destinationURL, destinationName }) => {
  const { refetch: refetchDestinations } = useListAllDestinationsForEnv();
  const params = new URLSearchParams(useLocation().search);
  const history = useHistory();

  const [completeOauthRequested, setCompleteOauthRequested] = useState(false);
  if (completeOauthRequested) {
    return null;
  }

  setCompleteOauthRequested(true);

  const errorURL = `${destinationURL}?error=Failed+to+complete+OAuth`;

  if (!params.get("state")) {
    const err = new Error("Unable to find 'state' parameter for OAuth.");
    console.error(err);
    Sentry.captureException(err);
    toast.error("Failed to complete OAuth");
    history.push(errorURL);
  }

  if (!params.get("code")) {
    const err = new Error("Unable to find 'code' parameter for OAuth.");
    console.error(err);
    Sentry.captureException(err);
    toast.error("Failed to complete OAuth");
    history.push(errorURL);
  }

  // if code last two chars are #_, then remove those for reddit-ads
  if (destinationName === "reddit-ads") {
    const code = params.get("code");
    if (code.slice(-2) === "#_") {
      params.set("code", code.slice(0, -2));
    }
  }

  const request = {
    integration_name: destinationName,
    state: params.get("state"),
    code: params.get("code"),
  };

  makeRequest("complete_oauth_flow", request)
    .then((response) => {
      if (!destinationURL) {
        window.close();
      } else {
        if (response.data.destination_id) {
          invalidateEventDefs();
          refetchDestinations();
          history.push(`${destinationURL}/${response.data.destination_id}`);
        } else {
          history.push(`${destinationURL}`);
        }
      }
    })
    .catch((err) => {
      console.error(err);
      toast.error("Failed to complete OAuth");
      Sentry.captureException(err);
      history.push(errorURL);
    });

  return null;
};
